import React from 'react';
import '../../styles/corpoClinico.css';
import SemFoto from '../../img/corpoClinico/sem_foto.jpg';

const CorpoClinico: React.FC = () => {
  return (
    <>
      <div className='title_clinic'>
        <h2 className="titulo" id="Corpo_Clinico">Corpo Clínico</h2>
      </div>
      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={SemFoto} alt="Gustavo" />
            </div>
            <div className="info-container">
              <h3 className="nome">Cristina Dias</h3>
              {/*<a href="https://lattes.cnpq.br/9350331289823529"
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>*/}
              <p className="descricao">
                "Pedagoga de crianças com transtornos do desenvolvimento e da aprendizagem, 
                oferecendo um apoio especializado, individualizado e comprometido com o progresso de cada uma.
                Acredito que, com o suporte certo, todas as crianças podem desenvolver o seu potencial e alcançar novas conquistas. 
                Este é um espaço seguro, onde a empatia e o conhecimento caminham juntos para fazer a diferença na vida das famílias."
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="botao-container">
        <br></br>
      </div>
    </>
  );
};

export default CorpoClinico;